<cx-org-sub-list [previous]="false">
  <button actions class="link" routerLink="../">
    {{ 'organization.done' | cxTranslate }}
  </button>
</cx-org-sub-list>
